import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Shield, Loader2, AlertCircle } from "lucide-react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#12121F] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <Shield className="w-6 h-6 text-[#C9A84C]" />
            <span className="text-white font-bold text-xl">MVS Dashboard</span>
          </div>
          <p className="text-[#9999B3] text-sm">Sign in to manage clients and projects</p>
        </div>
        
        <form onSubmit={handleSubmit} className="bg-[#1A1A2E] border border-[#252540] rounded-xl p-6 space-y-4" data-testid="login-form">
          {error && (
            <div className="flex items-center gap-2 p-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm" data-testid="login-error">
              <AlertCircle className="w-4 h-4 flex-shrink-0" />
              {error}
            </div>
          )}
          <div>
            <label className="text-[#9999B3] text-xs mb-1.5 block">Email</label>
            <Input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="admin@getmvs.net" className="bg-[#12121F] border-[#353555] text-white placeholder:text-[#6B6B85] focus:border-[#C9A84C] h-11" data-testid="login-email" />
          </div>
          <div>
            <label className="text-[#9999B3] text-xs mb-1.5 block">Password</label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Password" className="bg-[#12121F] border-[#353555] text-white placeholder:text-[#6B6B85] focus:border-[#C9A84C] h-11" data-testid="login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#C9A84C] hover:bg-[#B09340] text-black font-bold rounded-lg py-2.5" data-testid="login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </Button>
        </form>
        
        <p className="text-center text-[#353555] text-xs mt-6">
          <a href="/" className="hover:text-[#9999B3] transition-colors">&larr; Back to getmvs.net</a>
        </p>
      </div>
    </div>
  );
}
